import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { updateUser } from "../../services/authService";

export default function Profile() {

    const user = JSON.parse(localStorage.getItem("user"));
    const [formData, setFormData] = useState({
        name: user.name,
        email: user.email,
        phone: user.phone,
        nationality: user.nationality,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const navigate = useNavigate();

    if (!user) {
        navigate("/login?returnTo=/my-profile");
        return;
    }

    const handleUpdateUser = (e) => {
        e.preventDefault();
        
        if (formData.newPassword && formData.confirmPassword && formData.newPassword !== formData.confirmPassword) {
            alert("New passwords do not match");
            return;
        }
        updateUser({...formData, _id: user._id}).then((data) => {
            localStorage.setItem("user", JSON.stringify(data));
            alert("User updated successfully!");
        }).catch(err => {
            alert("Failed to update user", err);
            console.error("Failed to update user:", err);
        });
    };

    return (
        <section className="trips">
            <header className="trips-header">
                <h1>Profile</h1>
            </header>

            <form onSubmit={handleUpdateUser}>
                <div className="form-grid">
                    <label htmlFor="name">Name</label>
                    <input type="text" name="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                </div>
                <div className="form-grid">
                    <label htmlFor="email">Email</label>
                    <input type="email" name="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                </div>
                <div className="form-grid">
                    <label htmlFor="phone">Phone</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                </div>
                <div className="form-grid">
                    <label htmlFor="nationality">Nationality</label>
                    <input type="text" name="nationality" value={formData.nationality} onChange={(e) => setFormData({ ...formData, nationality: e.target.value })} />
                </div>
                <div className="child-section">
                    <h2>Change Password</h2>
                    <div className="child-card">
                        <div className="child-form">
                            <label htmlFor="oldPassword">Old Password</label>
                            <input type="password" name="oldPassword" value={formData.oldPassword} onChange={(e) => setFormData({ ...formData, oldPassword: e.target.value })} />
                        </div>
                        <div className="child-form">
                            <label htmlFor="newPassword">New Password</label>
                            <input type="password" name="newPassword" value={formData.newPassword} onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })} />
                        </div>
                        <div className="child-form">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })} />
                        </div>
                    </div>

                    <div className="">
                        <button type="submit" className="btn-primary">Update</button>
                    </div>
                </div>
            </form>
        </section>
    );
}